import React from 'react';

interface AppIconProps {
  className?: string;
  size?: number;
}

export const AppIcon: React.FC<AppIconProps> = ({ className = '', size }) => {
  return (
    <img
      src="/icons/icon-192x192.png"
      alt="MyWine"
      className={className}
      style={size ? { width: size, height: size } : undefined}
    />
  );
};
